import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import variableCommand from './variableCommand'
// 方法引入
import {
    toWidget,
    viewToModelPositionOutsideModelElement
} from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';
import {
    SCHEMA_NAME,
    COMMAND_NAME,
} from "./constant";
import DblclickObserver from "./dblclickObserver";
export default class VariableEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    static get pluginName() {
        return "variableEditing";
    }
    // 允许携带哪些属性
    allowAttributeArr = ["value", "data-base", "data-title", "data-probable", "data-details", "data-varcode", "data-type", "data-filter"];
    styleArr = ['color', 'font-weight']
    init() {
        const editor = this.editor;
        this._defineSchema();
        this._defineConverters();
        // COMMAND_NAME
        editor.commands.add(COMMAND_NAME, new variableCommand(editor));
        editor.editing.view.addObserver(DblclickObserver);
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        // schema.extend('$text', {
        // allowAttributes: ["value", "variableStr", SCHEMA_NAME],
        // });
        schema.register(SCHEMA_NAME, {
            isInline: true, // 是否为行内元素
            isObject: true, // 是否为一个整体
            allowWhere: "$text", // 允许在哪个 schema 插入
            allowAttributes: this.allowAttributeArr.concat(this.styleArr)
        });
    }
    //model <=>html 转换器
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for("editingDowncast").elementToElement({
            model: SCHEMA_NAME,
            view: (modelElement, { writer }) => {
                console.log("editingDowncast");
                const element = this.createDowncastElement(modelElement, writer);
                return toWidget(element, writer);
            },
        });
        conversion.for("dataDowncast").elementToElement({
            model: SCHEMA_NAME,
            view: (modelElement, { writer }) => {
                console.log("dataDowncast");
                const element = this.createDowncastElement(modelElement, writer);
                return element
            }
        });
        conversion.for("upcast").elementToElement({
            view: {
                name: "span",
            },
            model: (view, { writer }) => {
                console.log(view);
                return this.createModel(view,writer);
            },
        });
    }
    _defineClick(target){
        this.listenTo(target, 'mousedown', (evt, data) => {
           console.log("mousedown",target);
        });
    }
    createDowncastElement(modelElement, writer) {
        const element = writer.createContainerElement("span");
        const value = modelElement.getAttribute("value");
        this.allowAttributeArr.map((k) => {
            writer.setAttribute(k, modelElement.getAttribute(k), element);
        });
        this.styleArr.map((k) => {
            if (modelElement.getAttribute(k)) {
                writer.setStyle(k, modelElement.getAttribute(k), element);
            }
        });
        const innerText = writer.createText(value);
        writer.insert(writer.createPositionAt(element, 0), innerText);
        this._defineClick(element);
        return element;
    }
    createModel(view,  writer ) {
        const params = {};
        this.allowAttributeArr.map((k) => {
            params[k] = view.getAttribute(k);
        });
        this.styleArr.map((k) => {
            params[k] = view.getStyle(k);
        });
        if(!params["value"]){
            return writer.createElement("span");
        }
        return writer.createElement(SCHEMA_NAME, params);
    }
}